<script lang="ts" setup>
import { BanknoteX } from 'lucide-vue-next'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../components/ui/tooltip'
import { usePejerBase } from '../../stores/pejerData'
import usePejerMutation from '../../usePejerMutation'
import DataStateButton from '../DataState/DataStateButton.vue'
const props = defineProps<{
  paymentReferenceID: string
  debtCollectionActivated: boolean
}>()

const pejer = usePejerBase()
const { mutateAsync, dataState } = usePejerMutation(
  pejer.urls.payments.updateDebtCollectionProperty,
  {
    queryKeys: [['payments']],
  }
)
</script>
<template>
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger as-child>
        <DataStateButton
          :data-state="dataState"
          variant="ghost"
          class="p-2 h-fit"
          @click.prevent.stop="
            mutateAsync({
              pathArgs: { id: paymentReferenceID },
              body: { debtCollectionActivated: !debtCollectionActivated },
            })
          "
        >
          <BanknoteX class="w-4 h-4" />
          {{
            debtCollectionActivated ? 'Debt Collection is Active' : 'Debt Collection is Deactivated'
          }}
        </DataStateButton>
      </TooltipTrigger>
      <TooltipContent>
        <p>
          {{
            debtCollectionActivated ? 'Debt collection is active' : 'Debt collection is deactivated'
          }}
        </p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
